<template>
  <div class="hours-detail-page">
    <!-- 顶部背景 -->
    <div class="header-bg">
      <div class="header-content">
        <div class="back-btn" @click="goBack">
          <van-icon name="arrow-left" />
        </div>
        <!-- 机构信息展示 -->
        <div class="org-info">
          <div class="org-name">{{ orgName || '全部机构' }}</div>
          <div class="date-range" v-if="dateRangeDisplay">{{ dateRangeDisplay }}</div>
        </div>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-card">
      <div class="stats-header">
        <div class="stats-title">
          <span class="title-icon" :class="typeIconClass"></span>
          {{ statsTitle }}
        </div>
      </div>
      <div class="stats-grid">
        <template v-if="detailType === 'class'">
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.totalHours }}</div>
            <div class="stat-label">老师总课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.studentHours }}</div>
            <div class="stat-label">学生总课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.classCount }}</div>
            <div class="stat-label">班级数量</div>
          </div>
        </template>
        <template v-else-if="detailType === 'personal'">
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.totalHours }}</div>
            <div class="stat-label">老师总课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.studentHours }}</div>
            <div class="stat-label">学员总课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.lessonCount }}</div>
            <div class="stat-label">上课次数</div>
          </div>
        </template>
        <template v-else>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.totalHours }}</div>
            <div class="stat-label">总课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.studentHours }}</div>
            <div class="stat-label">学生课时</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewData.lessonCount }}</div>
            <div class="stat-label">上课课次</div>
          </div>
        </template>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="list-section">
      <div class="list-header">
        <span>明细列表</span>
        <div class="list-header-right">
          <div v-if="detailType === 'teacher' || detailType === 'classTeacher'" class="search-wrap">
            <van-icon class="search-icon" name="search" />
            <input
              v-model="searchKey"
              class="search-input"
              type="text"
              :placeholder="detailType === 'teacher' ? '搜索老师姓名' : '搜索班主任姓名'"
            />
            <van-icon
              v-if="searchKey"
              class="clear-icon"
              name="clear"
              @click="searchKey = ''"
            />
          </div>
          <span class="list-count">共 {{ filteredDataList.length }} 条</span>
        </div>
      </div>
      <div class="list-content" :class="{ 'list-content--class-hours': detailType === 'class' || detailType === 'personal' }">
        <template v-if="filteredDataList.length > 0">
          <!-- 班级类型表头 -->
          <div v-if="detailType === 'class'" class="list-item header" style="min-width: 580px">
            <span class="col-class-name">班级</span>
            <span class="col-class-code">班级编号</span>
            <span class="col-hours-compact">老师课时</span>
            <span class="col-hours-compact">学生课时</span>
            <span class="col-hours-compact" v-if="!isHideTuition">学费消耗</span>
            <span class="col-hours-compact">出勤人次</span>
            <span class="col-hours-compact">应到人次</span>
            <span class="col-hours-compact">出勤率</span>
          </div>
          <!-- 个性化类型表头 -->
          <div v-else-if="detailType === 'personal'" class="list-item header" style="min-width: 500px">
            <span class="col-personal-period">班级名称</span>
            <span class="col-hours-compact">科目</span>
            <span class="col-hours-compact">老师</span>
            <span class="col-hours-compact">上课次数</span>
            <span class="col-hours-compact">到课人次</span>
            <span class="col-hours-compact">老师课时</span>
            <span class="col-hours-compact">学员课时</span>
            <span class="col-hours-compact" v-if="!isHideTuition">学员消耗金额</span>
            
          </div>
          <!-- 老师/班主任类型表头 -->
          <div v-else class="list-item header" style="min-width: 660px">
            <span class="col-rank header-col">排名</span>
            <span class="col-name header-col">姓名</span>
            <span class="col-hours-compact header-col">课次</span>
            <span class="col-hours-compact header-col">老师课时</span>
            <span class="col-hours-compact header-col">班课课时</span>
            <span class="col-hours-compact header-col">1V1课时</span>
            <!-- v-if="detailType === 'teacher'" -->
            <span class="col-hours-compact header-col">1V2课时</span>
            <span class="col-hours-compact header-col">学生课时</span>
            <span class="col-hours-compact header-col" v-if="!isHideTuition">学费消耗</span>
            <span class="col-hours-compact header-col">出勤人次</span>
            <span class="col-hours-compact header-col">应到人次</span>
            <span class="col-hours-compact header-col">出勤率</span>
            <span class="col-hours-compact header-col">班课出勤率</span>
          </div>

          <div
            v-for="(item, index) in filteredDataList"
            :key="index"
            class="list-item"
            :style="`min-width: ${detailType === 'class' ? '580px': detailType === 'personal' ? '500px': '660px'} `"
            :class="{
              odd: index % 2 === 1,
              top3: index < 3 && detailType !== 'class' && detailType !== 'personal',
              'list-item--class-hours': detailType === 'class' || detailType === 'personal',
            }"
          >
            <!-- 班级类型内容 -->
            <template v-if="detailType === 'class'">
              <span class="col-class-name">{{ item.className }}</span>
              <span class="col-class-code">{{ item.classCode }}</span>
              <span class="col-hours-compact highlight">{{ item.teacherHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.studentHours || 0 }}</span>
              <span class="col-hours-compact" v-if="!isHideTuition">{{ item.studentAmount || 0 }}</span>
              <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
              <span class="col-hours-compact">{{ item.expectedAttendanceCount || 0 }}</span>
              <span class="col-hours-compact">{{ formatAttendanceRate(item.attendanceRate) }}</span>
            </template>
            <!-- 个性化类型内容 -->
            <template v-else-if="detailType === 'personal'">
              <span class="col-personal-period">{{ item.className || '-' }}</span>
              <span class="col-hours-compact">{{ item.subject || '-' }}</span>
              <span class="col-hours-compact">{{ item.teacherName || '-' }}</span>
              <span class="col-hours-compact">{{ item.lessonCount || 0 }}</span>
              <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.teacherClassHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.studentClassHours || 0 }}</span>
              <span class="col-hours-compact" v-if="!isHideTuition">{{ formatAmount(item.studentAmount) }}</span>
              
            </template>
            <!-- 老师/班主任类型内容 -->
            <template v-else>
              <span class="col-rank">
                <span class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
              </span>
              <span
                class="col-name"
                :class="{ 'teacher-link': detailType === 'teacher' }"
                @click="detailType === 'teacher' && goToTeacherDetail(item)"
              >
                {{ item.teacherName || item.classTeacherName }}
              </span>
              <span class="col-hours-compact">{{ item.lessonCount || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.teacherHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.classCourseTeacherHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.oneToOneTeacherHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.oneToTwoTeacherHours || 0 }}</span>
              <span class="col-hours-compact highlight">{{ item.studentHours || 0 }}</span>
              <span class="col-hours-compact" v-if="!isHideTuition">{{ item.studentAmount || 0 }}</span>
              <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
              <span class="col-hours-compact">{{ item.expectedAttendanceCount || 0 }}</span>
              <span class="col-hours-compact">{{ formatAttendanceRate(item.attendanceRate) }}</span>
              <span class="col-hours-compact">{{ formatAttendanceRate(item.classCourseAttendanceRate) }}</span>
            </template>
          </div>
        </template>
        <EmptyData v-else tips="暂无数据" />
      </div>
    </div>

    <!-- 日期筛选面板 -->
    <van-popup
      v-model:show="showDateFilter"
      closeable
      position="bottom"
      round
    >
      <DateFilterPanel
        :config="{ quickType: currentQuickType }"
        @submit="handleDateFilterSubmit"
        @reset="handleDateFilterReset"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { QUICK_KEY, QUICK_TEXT, getDateRangeByType } from '@/components/dateFilterPanel/utils.js'
import DateFilterPanel from '@/components/dateFilterPanel/DateFilterPanel.vue'
import EmptyData from '@/components/EmptyData.vue'
import { postHourClassStatistics, postHourTeacherRanking, postHourClassTeacherStatistics, postHourPersonalStatistics } from '@/api/report'

const route = useRoute()
const router = useRouter()

// 详情类型：class | teacher | classTeacher | personal
const detailType = ref(route.query.type || 'class')
const orgId = ref(route.query.orgId || '')
const orgName = ref(route.query.orgName || '')
const startDate = ref(route.query.startDate || '')
const endDate = ref(route.query.endDate || '')

const userType = ref('')

// 是否隐藏学费消耗（userType为22时隐藏）
const isHideTuition = computed(() => userType.value === '22')

// 日期范围显示
const dateRangeDisplay = computed(() => {
  if (startDate.value && endDate.value) {
    return `${startDate.value} 至 ${endDate.value}`
  }
  return ''
})

// 日期筛选
const showDateFilter = ref(false)
const currentQuickType = ref(QUICK_KEY.currentMonth)
const currentDateRange = ref([])

// 日期筛选按钮展示文案
const currentDateRangeDisplay = computed(() => {
  const type = currentQuickType.value
  const range = currentDateRange.value
  if (type === QUICK_KEY.custom && Array.isArray(range) && range.length >= 2) {
    return `${range[0]} ~ ${range[1]}`
  }
  return QUICK_TEXT[type] || '选择时间'
})

const handleDateFilterSubmit = ({ quickType, dateRange }) => {
  currentQuickType.value = quickType
  currentDateRange.value = dateRange
  showDateFilter.value = false
  loadData()
}

const handleDateFilterReset = ({ quickType, dateRange }) => {
  currentQuickType.value = quickType
  currentDateRange.value = dateRange
  showDateFilter.value = false
  loadData()
}

// 初始化日期范围
currentDateRange.value = getDateRangeByType(QUICK_KEY.currentMonth)

// 页面标题
const pageTitle = computed(() => {
  const titles = {
    class: '班级课时详情',
    teacher: '老师课时详情',
    classTeacher: '班主任课时详情',
    personal: '个性化课时详情'
  }
  return titles[detailType.value] || '课时详情'
})

// 统计标题
const statsTitle = computed(() => {
  const titles = {
    class: '班级课时统计',
    teacher: '老师课时统计',
    classTeacher: '班主任课时统计',
    personal: '个性化课时统计'
  }
  return titles[detailType.value] || '课时统计'
})

// 类型图标样式
const typeIconClass = computed(() => {
  const classes = {
    class: 'class-icon',
    teacher: 'teacher-icon',
    classTeacher: 'head-icon',
    personal: 'personal-icon'
  }
  return classes[detailType.value] || ''
})

// 统计数据
const overviewData = ref({
  totalHours: 0,
  classCount: 0,
  studentHours: 0,
  lessonCount: 0
})

// 数据列表
const dataList = ref([])

// 搜索关键字
const searchKey = ref('')

// 过滤后的数据列表
const filteredDataList = computed(() => {
  if (!searchKey.value) {
    return dataList.value
  }
  const key = searchKey.value.toLowerCase()
  return dataList.value.filter(item => {
    if (detailType.value === 'teacher') {
      return (item.teacherName || '').toLowerCase().includes(key)
    } else if (detailType.value === 'classTeacher') {
      return (item.classTeacherName || '').toLowerCase().includes(key)
    }
    return true
  })
})

// 格式化出勤率
const formatAttendanceRate = (rate) => {
  if (rate === null || rate === undefined || rate === '') return '0%'
  const num = Number(rate)
  if (isNaN(num)) return '0%'
  return `${(num)}%`
}

// 金额格式化（保留两位小数）
const formatAmount = (amount) => {
  const num = Number(amount) || 0
  return num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
}

// 返回上一页
const goBack = () => {
  router.back()
}

// 跳转到老师详情页面
const goToTeacherDetail = (item) => {
  const teacherId = item.teacherId || item.classTeacherId || ''
  const teacherName = item.teacherName || item.classTeacherName || ''
  if (!teacherId) {
    console.warn('老师ID不存在，无法跳转')
    return
  }
  router.push({
    path: '/teacherDetail',
    query: {
      teacherId,
      teacherName,
      orgId: orgId.value,
      orgName: orgName.value,
      startDate: startDate.value,
      endDate: endDate.value
    }
  })
}

// iframe消息处理：接收web端导出参数请求
const handleIframeMessage = (event) => {
  const { data } = event
  if (data && data.type === 'getExportParams') {
    // 获取当前选中的参数
    // HoursDetail页面从路由参数和内部状态获取
    const orgId = route.query.orgId || ''
    const start = currentDateRange.value?.[0] || startDate.value || ''
    const end = currentDateRange.value?.[1] || endDate.value || ''

    // 向web端返回参数
    if (event.source && event.source.postMessage) {
      event.source.postMessage(
        {
          type: 'exportParams',
          orgId,
          startDate: start,
          endDate: end
        },
        '*'
      )
    }
  }
}

// 加载数据
const loadData = async () => {
  const start = startDate.value
  const end = endDate.value

  if (!start || !end) return

  const params = {
    orgId: orgId.value,
    startDate: start,
    endDate: end
  }

  try {
    let res

    if (detailType.value === 'class') {
      res = await postHourClassStatistics(params)
      console.log('班级课时详情:', res)
    } else if (detailType.value === 'teacher') {
      res = await postHourTeacherRanking(params)
      console.log('老师课时详情:', res)
    } else if (detailType.value === 'classTeacher') {
      res = await postHourClassTeacherStatistics(params)
      console.log('班主任课时详情:', res)
    } else if (detailType.value === 'personal') {
      res = await postHourPersonalStatistics(params)
      console.log('个性化课时详情:', res)
    }

    if (res.code === '00' && res.data) {
      if (detailType.value === 'personal') {
        dataList.value = res.data.map(item => ({
          ...item,
          studentClassHours: item.studentHours || 0,
          teacherClassHours: item.teacherHours || 0
        }))
      } else {
        dataList.value = res.data
      }

      if (detailType.value === 'class') {
        overviewData.value = {
          totalHours: dataList.value.reduce((sum, item) => sum + (item.teacherHours || 0), 0),
          classCount: dataList.value.length,
          studentHours: dataList.value.reduce((sum, item) => sum + (item.studentHours || 0), 0),
          lessonCount: 0
        }
      } else if (detailType.value === 'teacher') {
        overviewData.value = {
          totalHours: dataList.value.reduce((sum, item) => sum + (item.teacherHours || 0), 0),
          classCount: 0,
          studentHours: dataList.value.reduce((sum, item) => sum + (item.studentHours || 0), 0),
          lessonCount: dataList.value.reduce((sum, item) => sum + (item.lessonCount || 0), 0)
        }
      } else if (detailType.value === 'classTeacher') {
        overviewData.value = {
          totalHours: dataList.value.reduce((sum, item) => sum + (item.teacherHours || 0), 0),
          classCount: 0,
          studentHours: dataList.value.reduce((sum, item) => sum + (item.studentHours || 0), 0),
          lessonCount: dataList.value.reduce((sum, item) => sum + (item.lessonCount || 0), 0)
        }
      } else if (detailType.value === 'personal') {
        overviewData.value = {
          totalHours: dataList.value.reduce((sum, item) => sum + (item.teacherHours || 0), 0),
          classCount: 0,
          studentHours: dataList.value.reduce((sum, item) => sum + (item.studentHours || 0), 0),
          lessonCount: dataList.value.reduce((sum, item) => sum + (item.lessonCount || 0), 0)
        }
      }
    } else {
      console.warn('课时详情接口返回数据格式异常:', res)
      dataList.value = []
      overviewData.value = {
        totalHours: 0,
        classCount: 0,
        studentHours: 0,
        lessonCount: 0
      }
    }
  } catch (error) {
    console.error('加载课时详情数据失败:', error)
    dataList.value = []
    overviewData.value = {
      totalHours: 0,
      classCount: 0,
      studentHours: 0,
      lessonCount: 0
    }
  }
}

onMounted(() => {
  
  userType.value = localStorage.getItem('userType') || ''
  loadData()
  // 添加iframe消息监听
  window.addEventListener('message', handleIframeMessage)
})

onUnmounted(() => {
  window.removeEventListener('message', handleIframeMessage)
})
</script>

<style lang="scss" scoped>
.hours-detail-page {
  background: linear-gradient(180deg, #e8f4ff 0%, #f5f6fa 30%);
  min-height: 100vh;
  padding-bottom: 20px;
  height: 100vh;
  overflow-y: scroll;
}

.header-bg {
  background: linear-gradient(135deg, #3478f6 0%, #5a9fff 100%);
  padding: 8px 16px 40px;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 16px rgba(52, 120, 246, 0.2);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
}

.org-info {
  flex: 1;
  margin-right: 36px;
  .org-name {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .date-range {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
  }
}

.back-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;

  &:active {
    opacity: 0.8;
  }
}

.header-title {
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.header-filter {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 13px;
  padding: 6px 12px;
  // background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  cursor: pointer;

  &:active {
    // background: rgba(255, 255, 255, 0.3);
  }
}

.stats-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(52, 120, 246, 0.08);
  margin: -30px 12px 16px 12px;
  padding: 20px;
  position: relative;
  z-index: 10;
}

.stats-header {
  margin-bottom: 20px;
}

.stats-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;

  .title-icon {
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #3478f6 0%, #5a9fff 100%);
    border-radius: 2px;

    &.class-icon {
      background: linear-gradient(180deg, #722ed1 0%, #b37feb 100%);
    }

    &.teacher-icon {
      background: linear-gradient(180deg, #13c2c2 0%, #36cfc9 100%);
    }

    &.head-icon {
      background: linear-gradient(180deg, #fa8c16 0%, #fdba74 100%);
    }

    &.personal-icon {
      background: linear-gradient(180deg, #eb2f96 0%, #f691d3 100%);
    }
  }
}

.stats-grid {
  display: flex;
  gap: 12px;
  flex-wrap: nowrap;
}

.stat-item {
  flex: 1;
  background: linear-gradient(135deg, #f8faff 0%, #fff 100%);
  border-radius: 14px;
  padding: 16px 12px;
  text-align: center;
  border: 1px solid #e8eef5;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #3478f6 0%, #5a9fff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}

.list-section {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(52, 120, 246, 0.08);
  margin: 0 12px 16px 12px;
  padding: 20px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;

  .list-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .list-count {
    font-size: 13px;
    font-weight: 400;
    color: #8c8c8c;
  }
}

.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border: 1px solid #e8eef5;
  border-radius: 20px;
  padding: 0 10px;
  height: 30px;
  min-width: 140px;
  transition: all 0.2s;

  &:focus-within {
    border-color: #3478f6;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(52, 120, 246, 0.1);
  }

  .search-icon {
    font-size: 14px;
    color: #999;
    flex-shrink: 0;
  }

  .search-input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 13px;
    color: #333;
    padding: 0 8px;
    min-width: 80px;

    &::placeholder {
      color: #999;
    }
  }

  .clear-icon {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    flex-shrink: 0;

    &:active {
      color: #666;
    }
  }
}

.list-content {
  margin-top: 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .list-item {
    min-width: 700px;
  }
}

.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 8px;

  &.header {
    background: #f5f7fa;
    color: #666;
    font-weight: 600;
    font-size: 13px;
    padding: 14px 16px;
    margin-bottom: 0;
  }

  &.odd {
    background: #fafafa;
  }

  &.top3 {
    .col-value {
      color: #ff6b6b;
      font-weight: 600;
    }
  }
}

.col-rank {
  width: 50px;
  flex-shrink: 0;
  text-align: center;
  padding: 0 4px;
}

.col-name {
  flex: 1 1 80px;
  min-width: 70px;
  max-width: 90px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 4px;

  &.teacher-link {
    color: #3478f6;
    cursor: pointer;
    font-weight: 500;

    &:active {
      opacity: 0.7;
    }
  }
}

.col-rank.header-col,
.col-name.header-col {
  padding: 0 4px;
}

.col-code {
  width: 80px;
  color: #666;
  font-size: 13px;
  flex-shrink: 0;
}

.col-hours,
.col-count {
  flex: 1 1 60px;
  min-width: 50px;
  max-width: 70px;
  text-align: center;
  color: #666;
  flex-shrink: 0;
}

.col-hours-compact {
  flex: 1 1 60px;
  min-width: 55px;
  max-width: 75px;
  text-align: center;
  color: #333;
  white-space: nowrap;
  flex-shrink: 0;
  word-break: break-word;
  padding: 0 6px;
  box-sizing: border-box;

  &.header-col {
    padding: 0 6px;
  }

  &.highlight {
    color: #3478f6;
    font-weight: 600;
    font-size: 15px;
  }
}

.col-personal-period {
  flex: 1.2 1 0;
  min-width: 100px;
  text-align: left;
  color: #333;
  word-break: break-word;
  padding: 0 6px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.col-value {
  width: 70px;
  text-align: right;
  color: #666;
  flex-shrink: 0;

  &.highlight {
    color: #3478f6;
    font-weight: 600;
    font-size: 15px;
  }
}

.list-content--class-hours {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .list-item--class-hours {
    align-items: flex-start;
    min-width: 700px;
    padding: 12px 16px;
  }

  .col-class-name,
  .col-class-code,
  .col-personal-period {
    flex: 1 1 0;
    min-width: 0;
    padding: 8px 6px;
    color: #333;
    text-align: center;
    word-break: break-word;
    box-sizing: border-box;
  }

  .col-class-name {
    text-align: left;
    flex: 1.2 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 80px
  }

  .col-personal-period {
    text-align: left;
    flex: 1.2 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 100px
  }

  .col-class-code {
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 80px
  }

  .col-hours-compact {
    flex: 1 1 0;
    min-width: 55px;
    max-width: 75px;
    text-align: center;
    color: #333;
    white-space: nowrap;
    flex-shrink: 0;
    word-break: break-word;
    padding: 0 6px;
    box-sizing: border-box;

    &.highlight {
      color: #3478f6;
      font-weight: 600;
      font-size: 15px;
    }
  }
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  background: #e8e8e8;
  color: #666;

  &.rank-1 {
    background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
    color: #fff;
  }

  &.rank-2 {
    background: linear-gradient(135deg, #c0c0c0 0%, #a8a8a8 100%);
    color: #fff;
  }

  &.rank-3 {
    background: linear-gradient(135deg, #cd7f32 0%, #b5651d 100%);
    color: #fff;
  }
}
</style>
